import { getConfigValue } from 'api/Firebase'
import React, { createContext, useContext, useEffect, useState } from 'react'

type RemoteConfigType = {
  enablePayments: boolean
}

const defaultValues: RemoteConfigType = {
  enablePayments: false,
}

const RemoteConfigContext = createContext<RemoteConfigType>(defaultValues)

export const useRemoteConfig = () => useContext(RemoteConfigContext)

export const RemoteConfigProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [config, setConfig] = useState<RemoteConfigType>(defaultValues)
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    const fetchConfig = async () => {
      const enablePayments = getConfigValue('enablePayments').asBoolean()
      setConfig({
        enablePayments: enablePayments ?? defaultValues.enablePayments,
      })
      setIsInitialized(true)
    }

    fetchConfig()
  }, [])

  if (!isInitialized) return null

  return (
    <RemoteConfigContext.Provider value={config}>
      {children}
    </RemoteConfigContext.Provider>
  )
}
